var _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _g2, _rect13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 167,
    viewBox: "0 0 26 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 12,
    height: 151,
    rx: 6,
    fill: "#EEEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_115_1118)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#292C27"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#292C27",
    stroke: "white",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 25,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 37,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 49,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 61,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 73,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 85,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#C4C4C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 97,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#30AF5B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 109,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#30AF5B"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 121,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#30AF5B"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 133,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#30AF5B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_115_1118)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 147,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#30AF5B"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 145.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#30AF5B",
    stroke: "white",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_115_1118",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_115_1118"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_115_1118",
    x: 0,
    y: 141,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_115_1118"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.d7d8b09990e69e5d5a46251139e2c318.svg";
export { ForwardRef as ReactComponent };